import "./actor.cb50ae3a.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec1c4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec1c4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $6TXE3 = parcelRequire("6TXE3");
var $ece75ac089a89716$exports = {};
$ece75ac089a89716$exports = import.meta.resolve("h2Vhi");


// start-snippet{displaymode.fillscreen}
const $01213039ae5fc3ff$var$game = new $6TXE3.Engine({
    canvasElementId: 'game',
    displayMode: $6TXE3.DisplayMode.FillScreen // highlight-line
});
// end-snippet{displaymode.fillscreen}
const $01213039ae5fc3ff$var$playerImage = new $6TXE3.ImageSource((0, (/*@__PURE__*/$parcel$interopDefault($ece75ac089a89716$exports))));
const $01213039ae5fc3ff$var$loader = new $6TXE3.Loader([
    $01213039ae5fc3ff$var$playerImage
]);
$01213039ae5fc3ff$var$game.start($01213039ae5fc3ff$var$loader).then(()=>{
    const actor = new $6TXE3.Actor({
        pos: $01213039ae5fc3ff$var$game.screen.center
    });
    actor.graphics.use($01213039ae5fc3ff$var$playerImage.toSprite());
    $01213039ae5fc3ff$var$game.currentScene.add(actor);
});


//# sourceMappingURL=fillscreen.e0925029.js.map
